import { useReducer } from 'react'
import type { State, Action } from './types'

const initialState: State = {
  pagination: {
    currentPage: 1,
    pageSize: 20
  },
  filters: {
    dateRange: {}
  },
  columnFilters: {
    entity: [],
    responseStatus: [],
    tokenValid: [],
    isOnHold: []
  }
}

function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'pagination/currentPage/set':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          currentPage: action.payload
        }
      }

    case 'pagination/pageSize/set':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          pageSize: action.payload,
          currentPage: 1
        }
      }

    case 'filters/dateRange/set':
      return {
        ...state,
        filters: {
          ...state.filters,
          dateRange: action.payload
        },
        pagination: {
          ...state.pagination,
          currentPage: 1
        }
      }

    case 'filters/clear':
      return {
        ...state,
        filters: {
          dateRange: {}
        },
        columnFilters: {
          entity: [],
          responseStatus: [],
          tokenValid: [],
          isOnHold: []
        },
        searchQuery: undefined,
        pagination: {
          ...state.pagination,
          currentPage: 1
        }
      }

    case 'searchQuery/set':
      return {
        ...state,
        searchQuery: action.payload,
        pagination: {
          ...state.pagination,
          currentPage: 1
        }
      }

    case 'columnFilters/set':
      return {
        ...state,
        columnFilters: action.payload,
        pagination: {
          ...state.pagination,
          currentPage: 1
        }
      }

    default:
      return state
  }
}

export function useWebhookLogsStore() {
  return useReducer(reducer, initialState)
}
